<header class="header-style-one three">
    <div class="container">
        <div class="top-bar">
            <p><i class="fa-regular fa-starship-freighter"></i> Síguenos en</p>
            <ul class="social-media">
                <li><a target="_blank"
                       href="https://www.facebook.com/TigerZenDo/"><i class="fa-brands fa-facebook-f"></i></a></li>
                <li><a target="_blank"
                       href="https://x.com/tigerzendo"><i class="flaticon-twitter"></i></a></li>
                <li><a target="_blank"
                       href="https://www.instagram.com/tigerzendo/"><i class="flaticon-instagram"></i></a></li>
            </ul>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <nav class="desktop-nav"
                 [ngClass]="{'sticky': isSticky}"
                 id="stickyHeader">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="d-flex-all justify-content-between">
                                <div class="header-logo">
                                    <a [routerLink]="['/']">
                                        <figure>
                                            <img [src]="logo"
                                                 alt="Logo">
                                        </figure>
                                    </a>
                                </div>

                                <div class="nav-bar">
                                    <ul>

                                        <li><a [routerLink]="['/']">Inicio</a></li>

                                        <!-- About Menu -->
                                        <li class="menu-item-has-children">
                                            <a href="javascript:void(0)">Nosotros</a>
                                            <ul class="sub-menu">
                                                <li><a [routerLink]="['/nosotros']">Quienes somos</a></li>
                                                <li><a [routerLink]="['/instalaciones']">Instalaciones</a>
                                                <li><a [routerLink]="['/convenios']">Convenios</a>
                                                </li>
                                            </ul>
                                        </li>

                                        <!-- Pages Menu -->
                                        <li class="menu-item-has-children">
                                            <a href="javascript:void(0)">Entrena con Nosotros</a>
                                            <ul class="sub-menu">

                                                <li><a [routerLink]="['/entrena-con-nosotros/horarios']">Horarios</a>
                                                </li>

                                                <!-- Services Submenu -->
                                                <!-- <li class="menu-item-has-children">
                                                    <a href="javascript:void(0)">Talleres</a>
                                                    <ul class="sub-menu">
                                                        <li><a [routerLink]="['/']">Danza</a></li>
                                                        <li><a [routerLink]="['/']">Dibujo</a>
                                                        </li>
                                                    </ul>
                                                </li> -->

                                                <!-- Classes Submenu -->
                                                <li class="menu-item-has-children">
                                                    <a href="javascript:void(0)">Artes Marciales</a>
                                                    <ul class="sub-menu">
                                                        <li><a [routerLink]="['/']">MMA</a></li>
                                                        <li><a [routerLink]="['/']">Tae Kwon Do</a></li>
                                                        <li><a [routerLink]="['/']">Muay Thai</a></li>
                                                    </ul>
                                                </li>

                                                <!-- Team Submenu -->
                                                <li class="menu-item-has-children">
                                                    <a href="javascript:void(0)">Entrenamientos Especiales</a>
                                                    <ul class="sub-menu">
                                                        <li><a [routerLink]="['/']">Clases Privadas
                                                                (individuales o grupales)</a></li>
                                                        <li><a [routerLink]="['/']">Clases para Empresas</a>
                                                        </li>
                                                        <li><a [routerLink]="['/']">Clases para Policía y
                                                                Ejército</a></li>
                                                    </ul>
                                                </li>


                                            </ul>
                                        </li>

                                        <li class="menu-item-has-children">
                                            <a href="javascript:void(0)">Tienda</a>
                                            <ul class="sub-menu">
                                                <li><a [routerLink]="['/tienda/mujer']">Mujer</a></li>
                                                <li><a [routerLink]="['/tienda/hombre']">Hombre</a></li>
                                                <li><a [routerLink]="['/tienda/kids']">Niños</a></li>
                                                <li><a [routerLink]="['/tienda/ofertas']">Promociones</a></li>
                                            </ul>
                                        </li>

                                        <li><a [routerLink]="['/contacto']">Contacto</a></li>
                                    </ul>

                                    <div class="extras">
                                        <app-cart-popup #cartPopup></app-cart-popup>

                                        <!-- <a href="#"
                                           id="desktop-menu"
                                           class="menu-start"
                                           (click)="cartPopup.openCart()">
                                            <svg id="ham-menue"
                                                 viewBox="0 0 100 100">
                                                <path class="line line1"
                                                      d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058">
                                                </path>
                                                <path class="line line2"
                                                      d="M 20,50 H 80"></path>
                                                <path class="line line3"
                                                      d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942">
                                                </path>
                                            </svg>
                                        </a> -->

                                        <!-- <a href="#"
                                           id="show"
                                           (click)="cartPopup.openCart()">
                                            <svg id="Shoping-bags"
                                                 enable-background="new 0 0 512 512"
                                                 viewBox="0 0 512 512"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g>
                                                    <path
                                                          d="m452 120h-60.946c-7.945-67.478-65.477-120-135.054-120s-127.109 52.522-135.054 120h-60.946c-11.046 0-20 8.954-20 20v352c0 11.046 8.954 20 20 20h392c11.046 0 20-8.954 20-20v-352c0-11.046-8.954-20-20-20zm-196-80c47.484 0 87.019 34.655 94.659 80h-189.318c7.64-45.345 47.175-80 94.659-80zm176 432h-352v-312h40v60c0 11.046 8.954 20 20 20s20-8.954 20-20v-60h192v60c0 11.046 8.954 20 20 20s20-8.954 20-20v-60h40z">
                                                    </path>
                                                </g>
                                            </svg>
                                        </a> -->

                                        <!-- Botón de Tema -->
                                        <a [routerLink]="['/iniciar-sesion']"
                                           class="theme-btn">Mi Cuenta</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <!-- Menú Móvil -->
            <div class="mobile-nav"
                 [ngClass]="{'open': !isCollapsed}"
                 id="mobile-nav">
                <div class="res-log">
                    <a [routerLink]="['/']">
                        <img [src]="logoResponsive"
                             alt="Responsive Logo">
                    </a>
                </div>
                <ul>
                    <li><a [routerLink]="['/']">Inicio</a></li>

                    <!-- ... -->
                    <li class="menu-item-has-children">
                        <a href="javascript:void(0)"
                           (click)="isCollapsed = !isCollapsed">About</a>
                        <ul class="sub-menu">
                            <li><a [routerLink]="['/nosotros']">Quienes somos</a></li>
                            <li><a [routerLink]="['/instalaciones']">Instalaciones</a>
                            <li><a [routerLink]="['/convenios']">Convenios</a>
                        </ul>
                    </li>

                    <li><a [routerLink]="['/contacto']">Contacto</a></li>
                </ul>
                <a href="javascript:void(0)"
                   id="res-cross"
                   (click)="isCollapsed = true">&times;</a>
            </div>
        </div>
    </div>
</header>
